import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/Login.css";

function Login() {
    const navigate = useNavigate();

    const [userData, setUser] = useState({ username: "", password: "" });
    const [userMessage, setUserMessage] = useState("");
    const [showPw, setShowPw] = useState(false);
    const [loading, setLoading] = useState(false);

    const canSubmit =
        userData.username.trim().length >= 5 && userData.password.trim().length >= 3;

    const onChange = (e) => {
        const { name, value } = e.target;
        setUser((prev) => ({ ...prev, [name]: value }));
    };

    const SignupForm = useCallback(
        async (event) => {
            event.preventDefault();
            if (!canSubmit || loading) return;

            setLoading(true);
            setUserMessage("");

            try {
                const payload = {
                    username: userData.username.trim(),
                    password: userData.password.trim(),
                };

                const res = await fetch(`https://rusoil.online/webapi/public/authenticate`, {
                    method: "POST",
                    mode: "same-origin",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        Authorization:
                            "Basic aipfYXV0aF9mZiVnZyQ6XiVoZmo5SGRqJkBuaEoxMjMwVmJjc2NzYWZ1XiViRA==",
                    },
                    body: JSON.stringify(payload),
                });

                // Try parse JSON safely; if server returns non-JSON on error, handle gracefully
                let data = null;
                try {
                    data = await res.json();
                } catch {
                    // ignore JSON parse error
                }

                if (!res.ok) {
                    // 401/500…
                    setUserMessage(data?.status || "Ошибка! Проверьте логин или пароль");
                    setLoading(false);
                    return;
                }

                // 200 OK
                if (data?.LoggedIn === true) {
                    setUserMessage("");
                    // // Avoid hard-coding admin phone; ask the server to tell if user is admin
                    // // For now keep your logic:
                    // if (payload.username === "89283820000") {
                    //     navigate("/kofegor911/admin", { replace: true });
                    // } else {
                    //     navigate("/", { replace: true });
                    // }

                    navigate("/", { replace: true });
                } else {
                    setUserMessage(data?.status || "Ошибка! Проверьте логин или пароль");
                }
            } catch (err) {
                setUserMessage("Ошибка! Проверьте логин или пароль");
            } finally {
                setLoading(false);
            }
        },
        [userData, canSubmit, loading, navigate]
    );

    return (
        <div className="Login">
            <div className="logo" />
            <div>
                <b className="msg">{userMessage}</b>
            </div>

            <div className="form">
                <form onSubmit={SignupForm}>
                    <div className="userInputsblock">
                        <input
                            type="tel"
                            name="username"
                            className="userinput"
                            placeholder="89282254545"
                            value={userData.username}
                            onChange={onChange}
                            autoComplete="username"
                            inputMode="numeric"
                        />
                    </div>
                    <div className="userInputsblock">
                        <input
                            type={showPw ? "text" : "password"}
                            name="password"
                            className="userinput"
                            placeholder="пароль"
                            value={userData.password}
                            onChange={onChange}
                            autoComplete="current-password"
                        />
                    </div>
                    <div className="checkboxblock">
                        <input
                            type="checkbox"
                            id="showPw"
                            checked={showPw}
                            onChange={(e) => setShowPw(e.target.checked)}
                        />
                        <label htmlFor="showPw">
                            <b id="checkboxtext"> Показать пароль</b>
                        </label>
                    </div>

                    <div>
                        <button
                            type="submit"
                            className="loginBtn"
                            disabled={!canSubmit || loading}
                            aria-busy={loading}
                        >
                            {loading ? "Вход..." : "ВОЙТИ"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Login;